type UseStringToDateReturn = Date
/**
 * Converts HHMM time string (typically generated in Quasar) to a
 * Javascript Date object.
 * @param HHMM HHMM string that Quasar expects.
 * @param options options object (set a different date if needed).
 */
export const useStringToDate = (
  HHMM: Date | string,
  options = { date: new Date() }
): UseStringToDateReturn => {
  let hours = '00'
  let minutes = '00'
  if (HHMM instanceof Date) {
    // We were given an actual date object, so grab the hours and minutes from it
    hours = String(HHMM.getHours())
    minutes = String(HHMM.getMinutes())
  } else {
    // We were given a string formatted as HH:MM, so split on that and assign the hours and minutes accordingly
    // Also, Prettier keeps inserting a semicolon to the beginning of the line for some reason, so I'm ignoring linting for the next line because it complains
    // eslint-disable-next-line
    ;[hours, minutes] = HHMM.split(':')
  }
  const date = new Date(options.date) // Copy the date so if we passed a custom one in we don't mutate the original

  // parseInt can have some funky behaviors with lots of leading zeroes, but with only one it works fine
  date.setHours(parseInt(hours))
  date.setMinutes(parseInt(minutes))

  //Need to set to 0 to trim time
  date.setSeconds(0)
  date.setMilliseconds(0)
  return date
}
